import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function RecommendedExpertsFields({ data, isLoading }) {
  // #region Data
  const { t } = useTranslation();
  const recommendedExperts = useMemo(
    () => (data ?? [])?.map((item, index) => ({ ...item, id: index + 1 })),
    [data]
  );
  // #endregion Data

  // #region Render
  const formatIndex = (_, { rowIndex }) => rowIndex + 1;

  const formatPhoneAndEmail = (value) => (
    <span>
      {value?.phone ?? ''}, {value?.email ?? ''}
    </span>
  );
  // #endregion Render

  return (
    <>
      <h4>{t('projectProposal.general.recommendedExpert.label')}</h4>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={recommendedExperts}
            className="p-datatable-gridlines"
            showGridlines
            dataKey="id"
            loading={isLoading}
            responsiveLayout="scroll"
          >
            <Column
              header={t('formLayout.numericalOrder')}
              body={formatIndex}
              style={{ textAlign: 'center' }}
            />
            <Column
              field="fullname"
              header={t('projectProposal.general.recommendedExpert.fullname')}
              style={{ minWidth: '12rem' }}
            />
            <Column
              field="researchLine"
              header={t('projectProposal.general.recommendedExpert.researchLine')}
              style={{ minWidth: '12rem' }}
            />
            <Column
              field="workplace"
              header={t('projectProposal.general.recommendedExpert.workplace')}
              style={{ minWidth: '12rem' }}
            />
            <Column
              header={`${t('projectProposal.general.recommendedExpert.phone')}, ${t(
                'projectProposal.general.recommendedExpert.email'
              )}`}
              body={formatPhoneAndEmail}
              style={{ minWidth: '10rem' }}
            />
          </DataTable>
        </div>
      </div>
    </>
  );
}

RecommendedExpertsFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
